const wrapperCls = "_61w6b25pk";
const imageCls = "_61ig51okt";
const videoWrapperCls = "_61vmuim78";
const fallbackIconCls = "_61fhi8cek";

export { fallbackIconCls, imageCls, videoWrapperCls, wrapperCls };
import "./thumbnail.style.linaria.module.css";
//# sourceMappingURL=thumbnail.style.js.map
